interface Chapter {
  start_time: number;
  title: string;
}

export const createChaptersVtt = (
  chapters: Chapter[],
  videoDuration: number,
): string => {
  const sortedChapters = [...chapters].sort(
    (a, b) => a.start_time - b.start_time,
  );

  const chaptersVtt = sortedChapters
    .map((chapter, index) => {
      const nextChapter = sortedChapters[index + 1];
      const startTime = formatVttTime(chapter.start_time);
      const endTime = formatVttTime(nextChapter?.start_time ?? videoDuration);

      return `${index + 1}\n${startTime} --> ${endTime}\n${chapter.title}`;
    })
    .join("\n\n");

  return `WEBVTT\n\n${chaptersVtt}\n`;
};

const formatVttTime = (timeInSeconds: number): string => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  const milliseconds = Math.round((timeInSeconds % 1) * 1000);

  const hoursString = hours.toString().padStart(2, "0");
  const minutesString = minutes.toString().padStart(2, "0");
  const secondsString = seconds.toString().padStart(2, "0");
  const millisecondsString = milliseconds.toString().padStart(3, "0");

  return `${hoursString}:${minutesString}:${secondsString}.${millisecondsString}`;
};
